import {Component, inject, Input} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'core-complaint-widget',
  imports: [],
  templateUrl: './complaint-widget.html',
  styleUrl: './complaint-widget.scss',
  host: {
    style: 'display: inline-flex;height: 100%;width: 100%;padding: 1.5rem 1rem;flex-direction: column;justify-content:space-between; gap: 2rem;'
  }
})
export class ComplaintWidget {
  private router = inject(Router);

  @Input()
  pendingAdmission: number | null = null;
  @Input()
  pendingResolution: number | null = null;

  goToComplaints() {
    this.router.navigate(['/compliants'], {queryParamsHandling: 'preserve'});
  }
}
